import React from 'react';
import * as Utils from 'utils';
import {projectBriefLength} from 'components/Commons/FieldTextarea';

export default function CartOptionsNoPrice({
  options,
  pagesIsNotExists,
    optionsWithPrice

}) {
  return (
    <>
      {(options.length > 0 || (projectBriefLength > 0 && pagesIsNotExists && optionsWithPrice <=0 )) &&
        <div className="app-cart-options">
          <div className="app-cart-option-list app-cart-option-list--no-price">
            {options.map((option, optionIndex) => {
              return (
                <div className="app-cart-option-item" key={optionIndex}>
                  <div className="app-cart-line">
                    <div className="app-cart-line-left">
                      <span className="app-cart-text-parameter-light">{Utils.replacer(option, 'priceLabelCart')}</span>
                    </div>
                    <div className="app-cart-line-right">
                      <span className="app-cart-text-value">{Utils.replacer(option, 'priceValueTextCart')}</span>
                    </div>
                  </div>
                </div>

              )
            })}
            {projectBriefLength > 0 && pagesIsNotExists && optionsWithPrice <=0 && (
                <div className="app-cart-option-item">
                  <div className="app-cart-line">
                    <div className="app-cart-line-left">
                      <span className="app-cart-text-parameter-light">Project brief</span>
                    </div>
                    <div className="app-cart-line-right">
                      <span className="app-cart-text-value">provided</span>
                    </div>
                  </div>
                </div>
            )}

          </div>
        </div>
      }

    </>
  )
}
